import React from 'react'

const AccArrowDown = () => (
  <svg width="20" height="8" viewBox="0 0 27 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 0.972656L13.5 13.9727L26 0.972656" stroke="black"/>
  </svg>
)

export default AccArrowDown;